export function numberFilter(val) {
  return Number(val) > 0 ? "+" + val : val
}